export default "__VITE_ASSET__wIMwurf$__"